import { Box, Button, chakra, Heading, Input, Table, Tbody, Td, Th, Thead, Tr, VStack, Text, useBreakpointValue } from "@chakra-ui/react";
import Layout from "../components/layouts/main";
import { motion } from "framer-motion";
import ScrollMarksTable from "../components/ScrollMarksTable";
import { Link } from "react-router-dom";

const MotionHeading = motion(Heading);

const MarksCalculatorPage = () => {
	const isMobile = useBreakpointValue({ base: true, md: false });

	return (
		<Layout>
			<VStack spacing={2} textAlign="center">
				<MotionHeading
					fontSize="clamp(1.5em, 2.8vw, 2.4em)"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
					textAlign={"center"}
					m={!isMobile ? 6 : 1}
				>
					Marks Calculator
				</MotionHeading>

				<Text fontSize="lg" color={'gray.500'}>
					These calculations may be approximate. If you have any additional information or if any data is incorrect, please let us know by <Link to="/contact"><chakra.span color={"#FF684B"}>contacting us</chakra.span></Link>.
				</Text>
			</VStack>

			<ScrollMarksTable />
		</Layout>
	);
};

export default MarksCalculatorPage;
